





























































































import Vue from "vue";
import PersonaService from "@/api/PersonaService";
import DatePicker from "@/components/shared/DatePicker.vue";
import AuthStore from "@/store/modules/AuthStore";
import { id } from "date-fns/locale";
export default Vue.extend({
  components: {
    DatePicker
  },
  data() {
    return {
      editedItem: {
        nombre: "",
        apellido: "",
        usuario: {},
      },
      identidadItems: [
        { text: "Cédula", value: "CED" },
        { text: "RUC", value: "RUC" },
        { text: "Pasaporte", value: "PAS" }
      ],
      ///sexoitems: ["Masculino", "Femenino"],
      sexoItems: [
        { text: "Masculino", value: "M" },
        { text: "Femenino", value: "F" }
      ]
    };
  },
  mounted() {
    this.getPersonData();
  },
  methods: {
    save() {
      PersonaService.update(this.editedItem)
        .then(() => {
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 4000,
            icon: "success",
            title: "Persona",
            text: "Guardada exitosamente"
          });
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 3000,
            icon: "error",
            title: "Persona",
            text: "No se pudo guardar"
          });
        });
    },
    getPersonData() {
        PersonaService.getPersona().then((response) => {
          this.editedItem = response;
          this.editedItem.fechaNacimiento = new Date(this.editedItem.fechaNacimiento).toISOString().substring(0, 10);
          if (this.editedItem.usuario) {
            this.editedItem.email = this.editedItem.usuario.email;
          }
        }).catch(() => {
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 3000,
            icon: "error",
            title: "Error",
            text: "No se pudo cargar la información de la persona"
          });
        });
    }
  },
  computed: {},
  watch: {}
});
